





























import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PatientMergeConfirm from './patient-merge-confirm.vue';
import PatientMergeSearch from './patient-merge-search.vue';
import PatientMergeSet from './patient-merge-set.vue';

@Component({
  components: {
    PatientMergeSearch,
    PatientMergeSet,
    PatientMergeConfirm
  },
  directives: {}
})
export default class PatientExistsDialog extends BaseComponent {
  @Prop()
  items:any

  choice = null;

  dialogFlag = true;
  
  done() {
    this.$emit('done', this.choice.id ? this.choice.id : null);
  }


  
}
